import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import './css/boutons.css';
import './css/liste.css';
import './css/site.css';
import './css/slider.css';
import './css/fontello/css/fontello.css';
import './css/spinner.css';

import App from './App';


import { BrowserRouter } from 'react-router-dom';

ReactDOM.render((
	<BrowserRouter>
		<App />
	</BrowserRouter>
), document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js